module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-02-17.4ed5c778.md";